import { Box, Typography, FormLabel, TextField, Button } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
import { toast } from "react-toastify";
import http from "../../utils/http-common";
import Logo from "../../assets/landing_page/Planshare.png";
export const VerifyPage = () => {
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateForm = () => {
    let tempErrors = {};
    let isValid = true;

    // Otp validation
    if (!otp) {
      tempErrors.otp = "Otp is required.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) Otp();
  };
  const Otp = async () => {
    try {
      const payload = { otp: otp, email: localStorage.getItem("field_email") };
      // const payload = { user_name, email, password };
      const response = await http.post(
        "/auth_service/otpverification",
        payload
      );

      if (response.data.otp_status === 1) {
        toast.success(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            {response.data.message}
          </div>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
        setTimeout(() => {
          navigate("/Login");
        }, 2000);
      } else if (response.data.otp_status === 2) {
        toast.error(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            {response.data.message}
          </div>
        );
        setTimeout(() => {
          navigate("/reg");
        }, 2000);
      } else if (response.data.otp_status === 3) {
        toast.success(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            {response.data.message}
          </div>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
        setTimeout(() => {
          navigate("/Login");
        }, 2000);
      } else if (response.data.otp_status === 5) {
        toast.error(response.data.message);
      } else {
        toast.error("Invalid OTP");
      }
    } catch (error) {
      console.error("Error creating account", error);

      if (error.response.data.otp_status === 1) {
        toast.success(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            {error.response.data.message}
          </div>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
        setTimeout(() => {
          navigate("/Login");
        }, 2000);
      } else if (error.response.data.otp_status === 2) {
        toast.error(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            {error.response.data.message}
          </div>
        );
        setTimeout(() => {
          navigate("/reg");
        }, 2000);
      } else {
        console.error("Error verifying OTP", error);
        toast.error(error.response.data.message);
      }
    }
  };
  const ResendOtp = async () => {
    try {
      const response = await http.post(
        "/auth_service/Resend-OTP",
        JSON.stringify({
          email: localStorage.getItem("field_email"),
        })
      );

      if (
        response.data.message ===
          "An Email sent to your account please verify" ||
        response.status === 201
      ) {
        setOtp("");
        toast.success(
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "24px",
              textAlign: "left",
              marginBottom: "8px",
              marginTop: "10px",
            }}>
            {response.data.message}
          </div>,
          {
            icon: (
              <img
                src={tick}
                alt='Success Icon'
                style={{ width: "20px", height: "20px", color: "#0057D5" }}
              />
            ),
          }
        );
      }
    } catch (error) {
      console.error("Error verifying OTP", error);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
        backgroundImage: `url('./background_1.jpg')`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundColor: "rgba(255, 255, 255, 0.3)", // White overlay with 50% opacity
    backgroundBlendMode: "overlay",
      }}>
      <Box
        sx={{
          // height: "100%",
          width: { xs: "80%", md: "27%" },
          border: "1px solid #E7E8EA",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          background: "#FFFFFF",
          borderRadius: "12px",
          p: "40px",
          pb: "10px",
        }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
        <img
                src={Logo}
                alt='planshare logo'
                style={{ width: "140px", height: "32px" }}
              />
        </Box>
        <Typography
          sx={{
            my: 1,
            fontWeight: "600",
            fontSize: "28px",
            color: "#040815",
          }}>
          Verify Your Account
        </Typography>
        <Typography
          sx={{ fontWeight: "500", fontSize: "16px", color: "#47474799" }}>
          Enter the OTP sent to your email to complete <br />
          your registration.
        </Typography>
        <Box
          sx={{
            my: 2,
            display: "flex",
            flexDirection: "column",
            width: "100%",
          }}>
          <FormLabel
            sx={{ fontWeight: "500", fontSize: "14px", color: "#040815" }}>
            Enter Code
          </FormLabel>
          <TextField
            placeholder='Enter Code'
            value={otp}
            error={!!errors.otp}
            helperText={errors.otp}
            onChange={(e) => setOtp(e.target.value.replace(/\s/g, ''))}
            sx={{
              my: 1,
              "& input": {
                height: "10px",
              },
            }}></TextField>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
            }}>
            <Button
              disableRipple
              sx={{
                textDecoration: "none",
                fontWeight: "500",
                fontSize: "12px",
                color: "#040815",
                cursor: "pointer",
                minWidth: "max-content",
                textTransform: "capitalize",
              }}
              onClick={ResendOtp}>
              Resend Code?
            </Button>
          </Box>
          <Button
            sx={{
              my: 3,
              background: "#FF2800",
              color: "#FFFFFF",
              textTransform: "capitalize",
              fontSize: "14px",
              fontWeight: "600",
              "&:hover": {
                background: "#e64a19",
              },
            }}
            onClick={() => handleSubmit()}>
            Verify
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
